import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#666E81\"><path d=\"M12 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z\"></path><path fill-rule=\"evenodd\" d=\"M18.16 10.93c.48.08.84.48.84.97 0 .63-.58 1.1-1.2.97-1.4-.28-2.8-.99-3.8-1.82v3.45h3c1.1 0 2 .9 2 2V21c0 .55-.45 1-1 1s-1-.45-1-1v-4h-5c-1.1 0-2-.9-2-2V9.1c0-1.03.73-1.95 1.75-2.07.47-.06.88.04 1.25.25h.01c.005 0 .008.002.01.005.003.002.005.005.01.005.23.11.44.26.61.45l1.29 1.43c.8.88 1.98 1.55 3.23 1.76Z\" clip-rule=\"evenodd\"></path><path d=\"M12.83 18c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 1 0 5.9 5.9h-2.07Z\"></path><path d=\"M12.83 18c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 1 0 5.9 5.9h-2.07Z\"></path></g>", 1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "Disabled"}) } }